<template>
    <div >
        <div style="margin: 0px; padding: 0px;">
            <div style="background: #FFFFFF; color: #666666; font-weight: 400; padding-top: 5px; padding-bottom: 5px; text-align: center; width: 100%; font-size: 12px; font-family: PingFangSC-Regular, PingFang SC;">
                <span>开发者：北京中网易企秀科技有限公司</span><br/>
                <span>应用名称：易企秀设计</span> <span style="padding-left: 20px;">版本号：4.36.0</span><br/>
                <span><a href="http://lps.eqxiul.com/ls/d2OO1JzU" style="color: #246DFF;">用户权限</a> | <a href="http://lps.eqxiul.com/ls/d2OO1JzU" style="color: #246DFF;">隐私协议</a></span>
            </div>
            <img :src="awaken_img" @click="openTargetApp" style="width: 100%; display: block;" title="awaken">
        </div>
        <div class="wxtip" v-show="wxtip">
            <img :src="awaken_img_wx_tip" style="width: 60%; padding-right: 16px;"/>
        </div>
    </div>
</template>

<script>
    import CallApp from 'callapp-lib'
    import MobileDetect from 'mobile-detect'
    import {awakenLogAdd} from "../api/log"

    export default {
        name: "awakenWxWork",
        data() {
            return {
                ua: '',
                md: '',
                os: '',
                awaken_img: '//asset.eqh5.com/app_awaken_10988?t=' + new Date().getFullYear() + "-" + new Date().getMonth()+ "-" + new Date().getDate() + "-" + new Date().getHours() +"&imageMogr2/auto-orient/thumbnail/" + (window.innerWidth * 1.5) + "x" + (window.innerHeight * 1.5),
                awaken_img_wx_tip: '//asset.eqh5.com/app_awaken_wxworktip?t=' + new Date().getTime(),
                wxtip: false,
                option: {
                    scheme: {
                        protocol: 'eqxiulink',
                    },
                    universal: {
                        host: 'appweb.eqxiu.com/wxwork',
                        pathKey: ''
                    },
                    appstore: 'https://apps.apple.com/app/apple-store/id933128780',
                    fallback: "market://details?id=cn.knet.eqxiu",
                    timeout: 500,
                },
                packageKey: "cn.knet.eqxiu"
            }
        },
        mounted() {
            this.ua = navigator.userAgent.toLowerCase();
            this.md = new MobileDetect(this.ua)
            let os = this.md.os();
            this.os = os;
            if (this.isWxWork() || this.isWx()) {
                this.wxtip = true;
            } else {
                this.wxtip = false;
            }

            //百度统计加入
            let script = document.createElement('script')
            script.type = 'text/javascript'
            script.text = `
                var _hmt = _hmt || [];
                (function() {
                  var hm = document.createElement("script");
                  hm.src = "https://hm.baidu.com/hm.js?93cd06ebda2db598041456a9d18c7299";
                  var s = document.getElementsByTagName("script")[0];
                  s.parentNode.insertBefore(hm, s);
                })();
            `
            document.getElementsByTagName('head')[0].appendChild(script);

            //统计使用
            window.ilog = {};
            window.ilog['product'] = 'app'; //填写产品名
            window.ilog['b_v'] = '1.0.0'; //数据版本
            window.ilog['b_t'] = 'App中间页'; //业务类型
            window.ilog['unm'] = '企业微信下载落地页'; //页面名字
            let params = this.$route.query
            let ccode = ''
            if (params.channelCode instanceof Array) {
                for (let code of params.channelCode) {
                    ccode += code + ","
                }
            } else {
                ccode = params.channelCode
            }
            ccode = ccode.indexOf(",") > -1 ? ccode.substring(0, ccode.length -1) : ccode
            this.option.universal.pathKey = 'channelCode=' + ccode

            if (!this.isWxWork() && !this.isWx()) {
                this.openApp();
            }
        },
        methods: {
            openTargetApp() {
                window.location.reload(true)
            },
            openApp() {
                debugger
                let ua = navigator.userAgent.toLowerCase();
                let md = new MobileDetect(ua)
                //指定页面唤起使用
                let params = this.$route.query;

                if (this.isMiuiBrowser() || this.isVivoBrowser() || this.isHeyTapBrowser()) {
                    this.option.fallback = "https://lib.eqh5.com/app/apk/eqxiu.apk"
                }
                var lib = new CallApp(this.option)
                let os = md.os();
                let model = "default";

                if (os == "iOS") {//ios系统的处理
                    model = md.mobile();
                } else if (os == "AndroidOS") {//Android系统的处理
                    var build = ua.split(";");
                    var i = build.findIndex(item => item.indexOf("build/") > -1);
                    if (i > -1) {
                        model = build[i].substring(0, build[i].indexOf("build/"));
                    }
                    model == "default" ? model = build[2] : "default"
                    if (model.trim() == "HarmonyOS"  || model.trim() == "harmonyos") {
                        model = build[3]
                    }
                }
                if (params.channelCode == undefined || params.channelCode == "") {
                    params.channelCode = "default";
                }

                let ccode = this.$cookies.get("channelCode")
                if (ccode != null && ccode != undefined && ccode != "") {
                    params.channelCode = params.channelCode + "," + ccode
                }
                // params.url = window.location.href
                awakenLogAdd({"model": model.trim(), "params": JSON.stringify(params), "channelCode": params.channelCode}).then(() => {
                    //下边open 会有跳转
                    lib.open({path: ''})
                })
            },
            isAndroid() {
                var md = new MobileDetect(navigator.userAgent.toLowerCase())
                var os = md.os();
                if (os == "AndroidOS") {
                    return true;
                }
                return false;
            },
            isiOS() {
                var md = new MobileDetect(navigator.userAgent.toLowerCase())
                var os = md.os();
                if (os == "iOS") {
                    return true;
                }
                return false;
            },
            isWx(){//判断是否为微信
                if(navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'){
                    return true;
                }
                return false;
            },
            isWxWork(){//判断是否为微信
                if(navigator.userAgent.toLowerCase().match(/wxwork/i) == 'wxwork'){
                    return true;
                }
                return false;
            },
            isMiuiBrowser() {
                if(navigator.userAgent.toLowerCase().match(/miuibrowser/i) == 'miuibrowser'){
                    return true;
                }
                return false;
            },
            isVivoBrowser() {
                if(navigator.userAgent.toLowerCase().match(/vivobrowser/i) == 'vivobrowser'){
                    return true;
                }
                return false;
            },
            isHeyTapBrowser() {
                if(navigator.userAgent.toLowerCase().match(/heytapbrowser/i) == 'heytapbrowser'){
                    return true;
                }
                return false;
            }
        }
    }
</script>

<style scoped>
    .wxtip {
        background: rgba(0,0,0,0.8);
        text-align: right;
        position: fixed;
        left:0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 998;
    }
</style>
